export const AddTask = ({taskstarted, setTackstarted, tasklist, setTesklist}) => {

    const handleTask = (e)=>{
        e.preventDefault();

        // add task
        const date = new Date();
        const newTask = {
            id : date.getTime(),
            name : e.target.task.value,
            time : date.toLocaleTimeString() + ' ' + date.toLocaleDateString()
        }

        setTesklist([...tasklist, newTask]);
        setTackstarted("");
        e.target.task.value = '';

    }
    
    return (

    <>
    <section className="addTask">
        <form onSubmit={(e)=>handleTask(e)}>
            <input type="text" name="task" />
            <button type="submit">Add</button>
        </form>

    </section>
    </>
  )
}
